import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import '../assets/css/home.css';
import { RouteComponentProps } from 'react-router';
import appConfigs from '../../../../config.json';
import StaticImageSlider from '../../../../components/StaticImageSlider';
import { IUserState } from '../../../../store/reducers/userReducer';
import flowimg from '../assets/img/bg.jpg';
import mhi from "../assets/img/slider-dec-v3.png";
import Footer from '../Footer';
import ImageSlider from '../../../../components/ImageSlider';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import { Box } from '@material-ui/core';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Header from '../Header';
type thisProps = RouteComponentProps;
interface PageState {
  showComponenrt: boolean;
  SelectedTabValue: string;


}

class Products_IBGate extends React.Component<thisProps, PageState> {
  constructor(props) {
    super(props);
    this.state = {
      showComponenrt: false,
      SelectedTabValue: "1",

    };
  }
  public async componentDidMount() {
    document.title =  appConfigs.CompanyTitle;

  }

  public render() {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      this.setState({ SelectedTabValue: newValue });
    };
    /*  const [name, setName] = useState("555"); */
    //  const userJwt = useSelector((state: IAppState) => state.UserState?state.UserState.jwt:null); -fluid-inner
    return (
      <div dir='ltr' id='page-about' >
      <Header />
    
           <main id="main">
    
           <section id="about" className="about">
            <div className="container" data-aos="fade-up">
              <div className="row gx-0">
           
                <div className="col-lg-6 f-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div className="content">
                   
                    <h3 >  سامانه پرداخت گروهی 
</h3>
                   <br></br>
                    <p>
                    یکی از خطوط اصلی کسب و کاری شرکت تجارت الکترونیک هوشمند تمدن، توسعه
                     و پیاده سازی سامانه‌های حوزه زیرساخت بانکی از جمله پرداخت گروهی 
                    جهت پرداخت سود مشتریان صندوق‌های سرمایه گذاری و 
                    همچنین پرداخت تتمه صدور و ابطال واحدهای سرمایه گذاران می‌باشد. در این راستا به 
                    دلیل الزام سازمان بورس و اوراق بهادار طبق ابلاغیه شماره 12020221 مورخ 17/02/1401 مبنی بر الکترونیکی شدن فرآیند پرداخت 
                    در صندوق‌های سرمایه‌گذاری، سامانه پرداخت گروهی 
                        بمنظور بهره‌برداری صندوق های سرمایه‌گذاری  
                    شرکت تامین سرمایه تمدن توسعه داده شده است.
                    </p>
             {/*        <div className="text-center text-lg-start">
                      <a href="#features" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center">
                        <span>بخش ها</span>
                        <i className="bi bi-arrow-right"></i>
                      </a>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-6 f-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
                  <img src={require("../assets/img/n-image-banner.png")} className="img-fluid  about-img" alt="" style={{maxWidth:"120%"}} />
                </div>
              </div>
              <div>
                
  
              </div>
            </div>
          </section>


          <section id="features" className="features">

            <div className="container" id="featureC" data-aos="fade-up">

              <div className="row feature-icons" data-aos="fade-up">
                <h3  >
                     بخش های اصلی  سامانه پرداخت گروهی
                </h3>

             
                <div className="row">


                  <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200" style={{marginTop:"8px"}}>
                    <div className="box">
                      <img src={require("../assets/img/audit.png")} className="img-fluid" alt="" />
                      <h3>                      اعتبارسنجی پرداخت

                      </h3>
                      <p>تمامی فرایند احراز هویت مشتری توسط هوش مصنوعی انجام می شود و افرادی که نام و نام خانوادگی شماره حساب شماره شبا و کدملی آنها اشتباه یا برای اشخاص دیگری باشد اعلام می کند و شما می توانید در صورت وجود هرگونه مغایرت آن را حذف یا اصلاح نمایید . در حقیقت تاکنون هیچ سرویس تطبیق شماره ملی با شماره حساب در بانک ارایه نشده است ولی تطبیق اسامی دریافتی با اسامی ثبت شده توسط کاربر از طریق هوش مصنوعی فراهم شده است.

                      </p>

                    </div>
                  </div>

                  <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200" style={{marginTop:"8px"}}>
                    <div className="box">
                      <img src={require("../assets/img/finpayment.png")} className="img-fluid" alt="" />
                      <h3>                       ایجاد سند پرداخت

                      </h3>
                      <p> دغدغه تمامی مدیران و کارشناسان مالی انجام به موقع پرداخت ها در طول روز است. در سامانه پرداخت گروهی قابلیت ایجاد پرداخت ها به صورت تکی و گروهی وجود دارد و می تواند تمامی پرداخت ها اعم از ساتنا و پایا و تراکنش های داخلی را انجام دهد. با پرداخت گروهی محدودیت سقف پرداخت به طور کامل حل شده و در هر زمان و مکانی امکان انجام پرداخت ها به صورت تکی و در قالب دسته نا محدود در کسری از زمان قابل پرداخت می باشد.

                      </p>

                    </div>
                  </div>



                  <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200" style={{marginTop:"30px"}}>
                    <div className="box">
                      <img src={require("../assets/img/onlinepay.png")} className="img-fluid" alt="" />
                      <h3>     پرداخت برخط گروهی

                      </h3>
                      <p> با فراخوانی سرویس های زیرساخت حوزه بانکی ، امکان پرداخت تکی یا پرداخت گروهی با توجه به نیاز کسب و کار بصورت اکترونیکی و برخط انجام می پذیرد

                      </p>
                    </div>
                  </div>


                  <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200" style={{marginTop:"30px"}}>
                    <div className="box">
                      <img src={require("../assets/img/wflowmg.png")} className="img-fluid" alt="" />
                      <h3>                     مدیریت جریان گردش کار

                      </h3>
                      <p> جریان کاری یا گردش کار روشی است که فرایندهای کسب و کارها را اتوماسیون و خودکار می کند. هدف از طراحی و ایجاد جریان کاری در سازمان ها مشارکت کارکنان در انجام پرداخت است . از امکانات مهم سامانه پرداخت گروهی امکان تعریف جریان گردش کار و مراحل تایید دستور پرداخت براساس نیاز هر مجموعه هست.

                      </p>
                    </div>
                  </div>


                </div>



              </div>

            </div>

          </section>
 
    

 

        </main>
        <Footer />
      </div>
    );
  };
}
export default connect()(Products_IBGate);
